// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { teacupWithHelpers } from 'app/scripts/views/internal/teacupWithHelpers';
import { View } from 'app/scripts/views/internal/View';
const t = teacupWithHelpers('select_member');

/* eslint-disable-next-line @trello/no-module-logic, @typescript-eslint/no-explicit-any */
const template = t.renderable(({ text, extraText, mentionCount }: any) =>
  t.li({ class: 'item js-member-item' }, () =>
    t.a(
      {
        href: '#',
        class: 'js-select-member ',
        title: text,
        autocompleteText: text,
      },
      () =>
        t.span('.text', { title: 'card' }, () =>
          t.text(`${extraText} (${mentionCount})`),
        ),
    ),
  ),
);

export class SelectFilterableView extends View {
  render() {
    this.$el.html(template(this.options));

    return this;
  }
}
